<div class="rs-wrapper-v4">
    <div class="container-text">
        <h1 [innerHTML]="title"></h1>
        <p [innerHTML]="subtitle"></p>
        <ng-content></ng-content>
    </div>
    <img class="hero-img" src="{{ imageUrl }}" alt="{{ imageSettings.alt ?? title }}" [attr.width]="imageSettings.width ?? 'auto'" [attr.height]="imageSettings.height ?? 'auto'">
</div>
